import * as React from "react";
import {FBFieldWithPriceBase, FBFieldWithPriceBaseState} from "FormBuilder/Fields/Core/FBFieldWithPriceBase";
import {PriceTypeEnum} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";
import {FBFieldBaseProps} from "FormBuilder/Fields/Core/FBFieldBase";
import {GetModel} from "FormBuilder/Events/GetModel";
import {FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {GetFieldOptions} from "FormBuilder/Events/GetFieldOptions";
import {GetField} from "FormBuilder/Events/GetField";
import {EventManager} from "shared/core/Events/EventManager";
import {FBButtonSelectionModel} from "./FBButtonSelection.Model";
import {ButtonOptionItem, FBButtonSelectionOptions} from "./FBButtonSelection.options";
import {ContainerDataRetriever} from "FormBuilder/Core/FormBuilder.Model";
import {OptionItem} from "FormBuilder/Fields/Options/OptionItem";
import './FBButtonSelection.css';
import {CSSProperties} from "react";
import {Price} from "FormBuilder/Utilities/Components/Price";
import {FontAwesomeIcon} from "shared/core/Controls/FontAwesome/FontAwesomeIcon";
import {FBMultipleOptionsBase} from "FormBuilder/Fields/Core/FBMultipleOptionsBase";

declare let require:any;
let context=require.context("./", true, /(?<!test)\.tsx?$/);
let library:any={};
for(let key of context.keys())
{
    library[key.substring(0,key.lastIndexOf('.'))]=key;
}

export default function  (libraryName) {
    libraryName='./'+libraryName.substring(18);//removed /InternalShared and adding ./

    if(library[libraryName]==null)
        throw 'Library not found '+libraryName;

    return context(library[libraryName]);


}

export class FBButtonSelection extends FBMultipleOptionsBase<FBButtonSelectionProps,FBTextFieldState>{

    static defaultProps: Partial<FBButtonSelectionProps> = {

    };

    constructor(props: FBButtonSelectionProps) {
        super(props);
    }



    componentWillReceiveProps(nextProps: Readonly<FBButtonSelection>, nextContext: any): void {
        if(this.Model.Parent.IsDesign)
        {
            let selectedOptions=this.props.Model.Options.Options.filter(x=>x.Selected);
            this.Model.SelectedValues=selectedOptions.length>0?selectedOptions.map(x=>x.Id):[];

            this.Model.Quantity=this.Model.Options.QuantityDefaultValue;
            this.Model.Refresh();
        }
    }

    SubRender() {
        if(this.Model.Options.ShowQuantitySelector&&this.Model.Options.PriceType!=PriceTypeEnum.quantity)
        {
            return(
                this.Model.Options.QuantityPosition == "bottom" || this.Model.Options.QuantityPosition == "right" ?
                    <React.Fragment>
                        {this.GetInput(this.Model.Options.QuantityPosition)}
                        {this.GetQuantityInput()}

                        {this.GetPriceOrRequiredBox()}

                    </React.Fragment>:
                    <React.Fragment>
                        {this.GetQuantityInput()}
                        {this.GetInput(this.Model.Options.QuantityPosition)}

                        {this.GetPriceOrRequiredBox()}

                    </React.Fragment>
            )
        }
        return(
            <React.Fragment>
                {this.GetInput('')}

                {this.GetPriceOrRequiredBox()}

            </React.Fragment>
        )


    }

    public GetLabel(valueOverwrite:string=''){
        let value=this.props.Model.Options.Label;
        if(valueOverwrite!='')
            value=valueOverwrite;

        if(value!='')
            return (
                <div className={'buttonSelectorLabel'} style={{fontWeight:'bold'}}>
                    <label>{value}</label>
                </div>
            );

        return null;
    }


    GetDynamicFieldNames(): any[] {
        return ['FBCheckBox'];
    }

    GetQuantityInput(){
        return(
            <div className={'rnTextFieldQuantity '+ this.Model.Options.QuantityPosition}>
                <div className={'rednaoLabel'}>
                    <label style={{fontWeight:'bold'}}>{this.Model.Options.QuantityLabel}</label>
                </div>
                <input className={'rnInputQuantity'} placeholder={this.Model.Options.QuantityPlaceholder} style={{width:'100%'}} type={'text'} value={this.Model.Quantity}
                       onChange={x=>{this.Model.Quantity=this.Model.ParseNumber(x.target.value as any);this.Model.Refresh()}}/>
            </div>

        )
    }


    GetInput(additionalClassNames:string){
        let numberOfColumns=parseInt(this.props.Model.Options.NumberOfColumns.toString());
        if(numberOfColumns==0||isNaN(numberOfColumns))
            numberOfColumns=3;

        let width=100/numberOfColumns;

        let remainingItems=this.Model.Options.Options.length%numberOfColumns;
        if(remainingItems!=0)
            remainingItems=numberOfColumns-remainingItems;

        let emptyItems=[];
        for(let i=0;i<remainingItems;i++)
            emptyItems.push(<div key={i} style={{width:`calc(${width}% - 10px)`}}/>)

        return (
            <div className={'rnTextFieldInput '+ additionalClassNames}>
                {this.GetLabel()}
                <div className={'buttonSelectionItemContainer'}>
                    {this.Model.Options.Options.map((option:ButtonOptionItem)=>
                        <div className={'ButtonSelectorItem '+(this.Model.SelectedValues.some(x=>x==option.Id)?'rnSelected':'')} key={option.Id} style={{display:'flex',alignItems:'center',width:`calc(${width}% - 10px)`,flexDirection:this.GetItemDirection(option)}} onClick={x=>this.ToggleSelected(option)}>
                            {this.GetImageControl(option)}
                            {this.GetLabelControl(option)}
                        </div>
                    )}

                    {emptyItems}


                </div>
            </div>

        );
    }

    public GetOptionId(optionId){
        let id=optionId.toString();
        id=this.props.Model.Options.Id+'_'+id;

        let formBuilder:ContainerDataRetriever=this.props.Model.FormBuilder;
        while(formBuilder.GetId()!=null)
        {
            id=formBuilder.GetId()+'_'+id;
            formBuilder=formBuilder.FormBuilder;
        }

        return 'field_'+id;
    }

    private ToggleSelected(imageItem: OptionItem) {
        let selectedItem=this.Model.SelectedValues.find(x=>x==imageItem.Id);
        this.Model.ToggleSelection(imageItem.Id,selectedItem===null||typeof selectedItem=="undefined");
    }

    public GetImageContainer(childrens:any)
    {
        return (
            <div style={{width:90,height:90,display:'flex',alignItems:'center',justifyContent:'center'}} className={'RNButtonSelectorImageContainer'}>
                {childrens}
            </div>
        )
    }

    private GetImageControl(option:ButtonOptionItem) {


        if(option.ImageType=="icon")
            return this.GetImageContainer(
                        <div style={{fontSize:80,maxWidth:80,maxHeight:80,textAlign:'center'}}>
                            <FontAwesomeIcon icon={option.Ref} style={{display:'block'}} />
                        </div>);

        if(option.ImageType=='image')
            return this.GetImageContainer(
                        <img style={{width:80,height:80}} src={option.Ref.URL}  alt={'Image not available'}/>
                    );

        return null;
    }

    private GetLabelControl(option: ButtonOptionItem) {
        let styles:CSSProperties={flexGrow:1,textAlign:'center'};
        if(option.ImageType=="none")
        {
            styles.display='flex';
            styles.flexWrap='wrap';
            styles.alignItems='center';
            styles.justifyContent='center';
        }

        return(
            <div className={'rnButtonSelectorLabelContainer'} style={styles}>
                <label className={'rnOptionItem'} htmlFor={this.GetOptionId(option.Id)} style={{cursor:"pointer"}}>{option.Label}</label>
                {this.Model.Options.ShowPriceInEachButton&& <Price Amount={parseFloat(option.RegularPrice)} SaleAmount={parseFloat(option.SalePrice)} style={{display:'block',marginTop:1}}/>}
            </div>
        )
    }

    private GetItemDirection(option: any):"column" | "column-reverse" | "row" | "row-reverse" {
        switch (this.Model.Options.ImagePosition) {
            case 'left':
                return 'row';
            case 'right':
                return 'row-reverse';
            case 'top':
                return 'column';
            case 'bottom':
                return 'column-reverse';
        }
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FBButtonSelectionProps extends FBFieldBaseProps{
    Model:FBButtonSelectionModel;
}

interface FBTextFieldState extends FBFieldWithPriceBaseState{

}





EventManager.Subscribe(GetModel,(event)=>{
    if(event.Options.Type==FieldTypeEnum.ButtonSelection)
        return new FBButtonSelectionModel(event.Options as FBButtonSelectionOptions,event.parent).Initialize(event.PreviousData);
});


EventManager.Subscribe(GetFieldOptions,(event)=>{
    if(event.Type==FieldTypeEnum.ButtonSelection)
        return new FBButtonSelectionOptions();
});

EventManager.Subscribe(GetField,(event)=>{
    if(event.Model.Options.Type==FieldTypeEnum.ButtonSelection)
        return <FBButtonSelection Model={event.Model as FBButtonSelectionModel} />
});

//#endregion "My Region"